module.exports = __webpack_public_path__ + "static/media/country_ai.b7e130df.webp";